'use client'

import { useEffect, useState } from 'react'

import dynamic from 'next/dynamic'

// Dev-only affiliate-link reveal. Enabled with `?dev=highlight-links`.
//
// Affiliate buy buttons are rendered through `AffiliateTrackable`, which stamps
// the real destination onto the element as `data-event-url` (plus `data-event-seller`
// etc.). Rather than wrap every call site, this single global overlay outlines every
// element carrying a non-empty `data-event-url` and shows its parsed URL + params on
// hover — so the affiliate links a page would otherwise hide behind a label are visible.
//
// Not translated on purpose: dev-only tooling (see rules/i18n.md).
const ActiveLinkRevealOverlay = dynamic(
  () => import('./link-reveal-overlay-active').then((m) => ({ default: m.LinkRevealOverlayActive })),
  {
    ssr: false,
    loading: () => null,
  }
)

const isHighlightLinksEnabled = (): boolean => {
  try {
    const url = new URL(window.location.href)
    return url.searchParams.get('dev') === 'highlight-links'
  } catch {
    return false
  }
}

export const LinkRevealOverlay = () => {
  const [enabled, setEnabled] = useState(false)

  useEffect(() => {
    setEnabled(isHighlightLinksEnabled())
  }, [])

  return enabled ? <ActiveLinkRevealOverlay /> : null
}
